module.exports = __webpack_public_path__ + "static/4-7ceb0472684eec3fd66878e38d01985a.jpg";